/**
 * Zeile mit den aktiven Filtern als entfernbare Chips.
 *
 * Aus `InserateFilterBar` herausgezogen, damit Inserate-Liste, Karte und die
 * Tourismus-Filterleiste dieselbe Darstellung teilen. Verhalten unverändert.
 */
export interface ActiveChip {
  id: string;
  label: string;
  onRemove: () => void;
}

export default function ActiveChipsRow({ chips }: { chips: ActiveChip[] }) {
  if (chips.length === 0) return null;
  return (
    <div className="flex flex-wrap gap-1.5">
      {chips.map(chip => (
        <span
          key={chip.id}
          className="inline-flex items-center gap-1 bg-blue-50 text-blue-800 border border-blue-200 rounded-full px-2.5 py-1 text-xs font-medium"
        >
          {chip.label}
          <button
            onClick={chip.onRemove}
            className="text-blue-400 hover:text-blue-700 ml-0.5 leading-none"
            aria-label="Filter entfernen"
          >
            ×
          </button>
        </span>
      ))}
    </div>
  );
}
